import { ChargeOnCompanyMappingEntity, EMPTY_CHARGE_ON_COMPANY_MAPPING_ENTITY } from "domain/entity/ChargeOnCompanyMapping/ChargeOnCompanyMappingEntity";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { MasterDataType } from "domain/entity/MasterData/MasterDataEntity";
import { ConsortiumRepository } from "domain/repository/ChargeDetailMaintenance/ConsortiumRepo";
import { ChargeOnCompanyMappingRepository } from "domain/repository/ChargeOnCompanyMapping/ChargeOnCompanyMappingRepo";
import { ChargeTypeRepository } from "domain/repository/ChargeType/ChargeTypeRepo";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { MasterDataRepository } from "domain/repository/MasterData/MasterDataRepo";
import { OpsLineRepository } from "domain/repository/OpsLine/OpsLineRepo";
import { VesselTypeRepository } from "domain/repository/VesselType/VesselTypeRepo";
import _ from "lodash";
import { createChargeOnCompanyMappingValidationSchema } from "presentation/constant/ChargeOnCompanyMapping/ChargeOnCompanyMappingValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { ChargeOnCompanyMappingModel } from "presentation/model/ChargeOnCompanyMapping/ChargeOnCompanyMappingModel";
import { DropdownProps } from "presentation/model/DropdownProps";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface ChargeOnCompanyMappingVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<ChargeOnCompanyMappingModel>> | ((value: SetStateAction<ChargeOnCompanyMappingModel>) => void),
    ],
    chargeOnCompanyMappingRepo: ChargeOnCompanyMappingRepository,
    chargeTypeRepo: ChargeTypeRepository,
    consortiumRepo: ConsortiumRepository,
    opsLineRepo: OpsLineRepository,
    masterDataRepo: MasterDataRepository,
    companyRepo: CompanyRepository,
    vesselTypeRepo: VesselTypeRepository,
}

export const ChargeOnCompanyMappingVM = ({ dispatch, chargeOnCompanyMappingRepo, chargeTypeRepo, consortiumRepo,
    opsLineRepo, masterDataRepo, companyRepo, vesselTypeRepo }: ChargeOnCompanyMappingVMProps) => {
    const [chargeOnCompanyMappingDispatch] = dispatch;

    const loadDropdownOption = async () => {

        const [chargeTypes, opsLines, companyCodeList, operatingTmls, chargeCodes,
            forwarderCodes, serviceCodes, soas, dummyCompanies, consortiums, vesselTypeList] = await Promise.all([
                chargeTypeRepo.getAllChargeTypesForCombobox(),
                opsLineRepo.getOpsLineForCombobox(),
                companyRepo.getAllCompanyForCombobox(),
                masterDataRepo.getMasterDataByKey(MasterDataType.TERMINAL),
                masterDataRepo.getMasterDataByKey(MasterDataType.HANDLING_CODE),
                masterDataRepo.getMasterDataByKey(MasterDataType.FORWARDER_CODE),
                masterDataRepo.getMasterDataByKey(MasterDataType.SERVICE),
                masterDataRepo.getMasterDataByKey(MasterDataType.SOA),
                masterDataRepo.getMasterDataByKey(MasterDataType.DUMMY_CHG_ON_BILL_TO),
                consortiumRepo.getAllConsortiums(),
                vesselTypeRepo.getVesselTypeForComboBox(),
            ]);

        let newChargeTypeList = _.orderBy(chargeTypes, ["chargeType", "subChargeType"]);
        let newChargeTypes = newChargeTypeList.filter(entity => entity.chargeCategory === 'GEN' || entity.chargeCategory === 'SYS');
        let chargeTypeDropdownOption: DropdownProps[] = [];
        let allSubChargeTypeDropdownOption: DropdownProps[] = [];
        let subChargeTypeDropdownOption: { [key: string]: DropdownProps[] } = {};
        newChargeTypes?.forEach(chgTypeEty => {
            const chgTypeExisted = chargeTypeDropdownOption?.find(chgType =>
                chgType.value === chgTypeEty.chargeType);
            if (!chgTypeExisted) {
                chargeTypeDropdownOption.push({
                    dropdownLabel: chgTypeEty.chargeType,
                    tagLabel: chgTypeEty.chargeType,
                    value: chgTypeEty.chargeType
                })
            }
            const subChgTypeExisted = allSubChargeTypeDropdownOption?.find(subChgType =>
                subChgType.value === chgTypeEty.subChargeType);
            if (!subChgTypeExisted && chgTypeEty.subChargeType) {
                allSubChargeTypeDropdownOption.push({
                    dropdownLabel: chgTypeEty.subChargeType,
                    tagLabel: chgTypeEty.subChargeType,
                    value: chgTypeEty.subChargeType
                })
            }
            if (chgTypeEty.subChargeType) {
                if (!subChargeTypeDropdownOption[chgTypeEty.chargeType]) {
                    subChargeTypeDropdownOption[chgTypeEty.chargeType] = [];
                }
                subChargeTypeDropdownOption[chgTypeEty.chargeType].push({
                    dropdownLabel: chgTypeEty.subChargeType,
                    tagLabel: chgTypeEty.subChargeType,
                    value: chgTypeEty.subChargeType
                });
            }
        });

        let opsLineDropdownOption: DropdownProps[] = [];
        opsLines?.forEach((opsLineEty) => {
            const opsExisted = opsLineDropdownOption?.find(opsLine =>
                opsLine.value === opsLineEty.opsLine);
            if (!opsExisted) {
                opsLineDropdownOption.push({
                    dropdownLabel: opsLineEty.opsLine,
                    tagLabel: opsLineEty.opsLine,
                    value: opsLineEty.opsLine
                })
            }
        })

        const activeCompanyCode = companyCodeList?.filter((compCode) => {
            return compCode.companyType !== 'MASTER' && compCode.companyType !== 'ALLIANCE' && compCode.status === 'CONFIRMED' && compCode.activeInd === 'Y';
        });
        const opsLineCompanyDropdownOptions = activeCompanyCode?.map((companyEty) => ({
            dropdownLabel: companyEty.companyCode,
            tagLabel: companyEty.companyCode,
            value: companyEty.companyCode,
        })) ?? [];

        let dummyCompanyCodeDropdownOptions = dummyCompanies?.map((dummyCompany) => ({
            dropdownLabel: dummyCompany.code,
            tagLabel: dummyCompany.code,
            value: dummyCompany.code,
        })) ?? []

        let companyCodeFilter = companyCodeList?.filter(compCode => compCode.companyType !== 'MASTER' && compCode.companyType !== 'ALLIANCE');

        let companyCodeDropdownOptions = companyCodeFilter?.map((company) => ({
            dropdownLabel: company.companyCode,
            tagLabel: company.companyCode,
            value: company.companyCode,
        })) ?? []
        companyCodeDropdownOptions = _.orderBy(companyCodeDropdownOptions, "dropdownLabel");

        const operatingTmlDropdownOptions = operatingTmls?.map((operatingTml) => ({
            dropdownLabel: operatingTml.code,
            tagLabel: operatingTml.code,
            value: operatingTml.code,
        })) ?? [];

        const chargeCodeDropdownOptions = chargeCodes?.map((chargeCode) => ({
            dropdownLabel: chargeCode.code,
            tagLabel: chargeCode.code,
            value: chargeCode.code,
        })) ?? [];

        const forwarderCodesDropdownOptions = forwarderCodes?.map((forwarderCode) => ({
            dropdownLabel: forwarderCode.code,
            tagLabel: forwarderCode.code,
            value: forwarderCode.code,
        })) ?? [];

        let consortiumCodeDropdownOptions = consortiums?.map((item) => ({
            dropdownLabel: item.consortiumCode,
            tagLabel: item.consortiumCode,
            value: item.consortiumCode,
        })) ?? []
        consortiumCodeDropdownOptions = _.orderBy(consortiumCodeDropdownOptions, "dropdownLabel");

        const serviceCodeDropdownOptions = serviceCodes?.map((serviceCode) => ({
            dropdownLabel: serviceCode.code,
            tagLabel: serviceCode.code,
            value: serviceCode.code,
        })) ?? [];

        const soaCodeDropdownOptions = soas?.map((soa) => ({
            dropdownLabel: soa.code,
            tagLabel: soa.code,
            value: soa.code,
        })) ?? [];

        const vesselTypeDropdownOption = vesselTypeList?.map((vesselType) => ({
            dropdownLabel: vesselType.vesselType,
            tagLabel: vesselType.vesselType,
            value: vesselType.vesselType,
        })) ?? [];

        chargeOnCompanyMappingDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                chargeTypeDropdownOptions: chargeTypeDropdownOption,
                subChargeTypeDropdownOptions: subChargeTypeDropdownOption,
                opsLineCompanyDropdownOptions: opsLineCompanyDropdownOptions,
                chargeOnCompanyDropdownOptions: [...dummyCompanyCodeDropdownOptions, ...companyCodeDropdownOptions],
                operatingTmlDropdownOptions: operatingTmlDropdownOptions,
                chargeCodeDropdownOptions: chargeCodeDropdownOptions,
                forwarderCodeDropdownOptions: forwarderCodesDropdownOptions,
                consortiumCodeDropdownOptions: consortiumCodeDropdownOptions,
                serviceCodeDropdownOptions: serviceCodeDropdownOptions,
                soaDropdownOptions: soaCodeDropdownOptions,
                vesselTypeDropdownOptions: vesselTypeDropdownOption,
                opsLineDropdownOptions: opsLineDropdownOption,
                allSubChargeTypeDropdownOptions: allSubChargeTypeDropdownOption,
            }
        }))
    }

    const searchAllChargeOnCompanyMappingList = async () => {
        chargeOnCompanyMappingDispatch(prevState => {
            return {
                ...prevState,
                currentRow: { ...EMPTY_CHARGE_ON_COMPANY_MAPPING_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                updatedRows: [],
                chargeOnCompanyMappingList: [],
            }
        })
        await chargeOnCompanyMappingRepo.searchAllChargeOnCompanyMappingList().then(data => {
            if (data) {
                // const newData = data.map(entity => ({
                //     ...entity,
                //     chargeOnCompanyCode: ChargeOnBillToCompanyPolicy().getChargeOnBillToCompanyKeyByValue(entity.chargeOnCompanyCode as string),
                //     alterableChargeOnCompany: ChargeOnBillToCompanyPolicy().getChargeOnBillToCompanyKeyByValue(entity.alterableChargeOnCompany as string),
                // }));
                chargeOnCompanyMappingDispatch(prevState => {
                    return {
                        ...prevState,
                        chargeOnCompanyMappingList: data,
                    }
                })
            } else {
                chargeOnCompanyMappingDispatch(prevState => {
                    return {
                        ...prevState,
                        chargeOnCompanyMappingList: [],
                    }
                })
            }
        })
    }

    const onApply = async (updatedRows: ChargeOnCompanyMappingEntity[]) => {


        return await chargeOnCompanyMappingRepo.onApply(updatedRows);
    }

    const updateSelectedRows = async (rows: ChargeOnCompanyMappingEntity[]) => {

        chargeOnCompanyMappingDispatch(prevState => {
            return {
                ...prevState,
                // chargeOnCompanyMappingList: [...allRows],
                selectedRows: rows,
                forceRefresh: !prevState.forceRefresh
            }
        })
    }

    const onRowDoubleClick = async (entity: ChargeOnCompanyMappingEntity) => {
        chargeOnCompanyMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: entity,
                currentRow: entity,
                isShowEditPanel: true,
            }
        })
    }

    const onHeaderFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        if (fieldKey === 'chargeType') {
            chargeOnCompanyMappingDispatch(prevState => {
                return {
                    ...prevState,
                    currentEditRow: {
                        ...prevState.currentEditRow,
                        subChargeType: val === prevState.currentEditRow.chargeType ? prevState.currentEditRow.subChargeType : ''
                    },
                }
            })
        }
        chargeOnCompanyMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onCloseEidtPanel = async () => {
        chargeOnCompanyMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: { ...EMPTY_CHARGE_ON_COMPANY_MAPPING_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        })
    }

    const onSave = async (currentRow: ChargeOnCompanyMappingEntity) => {
        const valResult = await Validation(createChargeOnCompanyMappingValidationSchema).ValidateFormOnly(currentRow);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            chargeOnCompanyMappingDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        return chargeOnCompanyMappingRepo.onSave(currentRow);
    }

    const onAddClick = async () => {
        chargeOnCompanyMappingDispatch(prevState => {
            const chargeOnCompanyCode = prevState.dynamicOptions.chargeOnCompanyDropdownOptions[0]?.value;
            return {
                ...prevState,
                currentEditRow: { ...EMPTY_CHARGE_ON_COMPANY_MAPPING_ENTITY, chargeOnCompanyCode: chargeOnCompanyCode },
                isShowEditPanel: true,
                isAdd: true,
            }
        })
    }
    const onResetClick = async (isAdd: boolean) => {
        chargeOnCompanyMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: isAdd ? { ...EMPTY_CHARGE_ON_COMPANY_MAPPING_ENTITY } : prevState.currentRow,
            }
        })
    }
    const onEditClick = async () => {
        chargeOnCompanyMappingDispatch(prevState => {
            return {
                ...prevState,
                isEdit: true,
            }
        })
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        chargeOnCompanyMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }

    const onSaveClicked = () => {
        chargeOnCompanyMappingDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    return {
        onCheckboxChange: onCheckboxChange,
        onEditClick: onEditClick,
        onResetClick: onResetClick,
        onSave: onSave,
        onAddClick: onAddClick,
        onCloseEidtPanel: onCloseEidtPanel,
        onHeaderFieldChange: onHeaderFieldChange,
        onRowDoubleClick: onRowDoubleClick,
        updateSelectedRows: updateSelectedRows,
        onApply: onApply,
        onSaveClicked: onSaveClicked,
        loadDropdownOption: loadDropdownOption,
        searchAllChargeOnCompanyMappingList: searchAllChargeOnCompanyMappingList,
    }
}